import {Pipe, PipeTransform} from '@angular/core';
import {ETipoUsuario} from '@core/models';
import { EEstado } from '@core/models/Estado.enumerador';

@Pipe({name: 'estadoDenuncia'})
export class estadoDenunciaPipe implements PipeTransform {
  transform(dato: number): any {
    if (!dato) {
      return dato;
    }

    switch (dato) {
      case EEstado.EN_PROCESO:
        return 'En Proceso';
      case EEstado.CERRADO:
        return 'Cerrado';
      case EEstado.EMITIDO:
        return 'Emitido';
    }
  }
}
